import React, { FC, ReactNode } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classes from './AuthErrorMessage.module.less';

type AuthErrorMessageProps = {
  children: string;
  // Drobniejsze linijki pod komunikatem — co zrobić dalej
  hint?: ReactNode;
};

// Błąd na ekranach przed logowaniem: grafitowa, nieprzezroczysta ramka pod formularzem, na szarej ścianie.
// Okienka w panelu nauczyciela zostają przy czerwonym ErrorMessage
const AuthErrorMessage: FC<AuthErrorMessageProps> = ({ children, hint }) => (
  <div className={classes.error} role="alert">
    <ExclamationCircleOutlined className={classes.icon} />
    <div>
      <div className={classes.message}>{children}</div>
      {hint && <div className={classes.hint}>{hint}</div>}
    </div>
  </div>
);

export default AuthErrorMessage;
